var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.267,
    height: 12.42,
    viewBox: "0 0 25.267 12.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.706,14.212H.677A.677.677,0,0,0,0,14.889v3.158a.677.677,0,0,0,.677.677H17.706v2.6a1.354,1.354,0,0,0,2.311.957l4.854-4.854a1.354,1.354,0,0,0,0-1.914l-4.854-4.854a1.354,1.354,0,0,0-2.311.957Z",
    transform: "translate(0 -10.258)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.57320f4f.svg";
export { ForwardRef as ReactComponent };